function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPetsAndAnimals = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.831,5.105C15.749,7.86 14.812,10.64 12.738,11.321C10.664,12.001 8.237,10.319 7.319,7.564C6.4,4.81 7.338,2.029 9.412,1.349C11.486,0.668 13.913,2.351 14.831,5.105ZM6.734,11.892C7.948,13.973 7.653,16.393 6.079,17.292C4.506,18.191 2.246,17.234 1.039,15.154C-0.168,13.074 0.114,10.653 1.687,9.754C3.261,8.855 5.521,9.812 6.728,11.892L6.734,11.892ZM4.731,24.901C8.096,15.828 14.074,13.523 16.725,13.523C19.377,13.523 25.355,15.828 28.72,24.901C28.951,25.524 29.054,26.192 29.054,26.86L29.054,26.962C29.054,28.619 27.712,29.961 26.055,29.961C25.317,29.961 24.585,29.871 23.872,29.691L18.222,28.279C17.239,28.035 16.212,28.035 15.229,28.279L9.579,29.691C8.866,29.871 8.134,29.961 7.396,29.961C5.739,29.961 4.397,28.619 4.397,26.962L4.397,26.86C4.397,26.192 4.5,25.524 4.731,24.901ZM27.371,17.292C25.798,16.393 25.503,13.973 26.717,11.892C27.93,9.812 30.184,8.855 31.757,9.754C33.33,10.653 33.626,13.074 32.412,15.154C31.198,17.234 28.945,18.191 27.371,17.292ZM20.199,11.321C18.125,10.64 17.188,7.86 18.106,5.105C19.024,2.351 21.451,0.668 23.525,1.349C25.599,2.029 26.537,4.81 25.619,7.564C24.7,10.319 22.273,12.001 20.199,11.321Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPetsAndAnimals);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pets-and-animals.e3f67b7b999203ba474b45c163bc5895.svg";